import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons/faInfoCircle';
import { faGear } from '@fortawesome/pro-solid-svg-icons/faGear';
import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash-es';
import { FormattedMessage, useIntl } from 'react-intl';
import { Tooltip } from 'ui-components/components/tooltip';
import { TooltipContent } from 'ui-components/components/tooltip/tooltip-content';
import { CollapsibleListSection } from 'ui-components/components/collapsible-list/collapsible-list-section';
import { CollapsibleListSectionHeader } from 'ui-components/components/collapsible-list/collapsible-list-section-header';
import { CollapsibleListSectionContent } from 'ui-components/components/collapsible-list/collapsible-list-section-content';
import { noop } from 'ui-components/default-props/noop';
import { BulkUpdateModelPropType } from '../../../../prop-types/bulk-update-model';
import { BulkJobDataPropType } from '../../../../prop-types/bulk-job-data';
import { LoadingIndicator } from 'ui-components/components/loading-indicator';
import { Button } from 'ui-components/components/button';
import { BulkAction } from '../../../../components/bulk-action';
import { BulkActions } from '../../../../enums/bulk-actions';
import { messages } from '../../messages';
import style from './apply-preset.module.less';
import { emptyObject } from 'ui-components/default-props/empty';

export const ApplyPreset = ({
  open = false,
  onClick = noop,
  disabled = false,
  isLoading = false,
  bulkUpdateJobId = '',
  isFedexHal = false,
  model = emptyObject,
  jobData = emptyObject,
  onModelChange = noop,
  applyPreset = noop,
  managePresets = noop,
  dragHandleProps,
}) => {
  const intl = useIntl();
  // noinspection JSValidateTypes
  return (
    <CollapsibleListSection disabled={disabled || isFedexHal} open={open && !disabled && !isFedexHal}>
      <CollapsibleListSectionHeader dragHandleProps={dragHandleProps} onClick={() => onClick(open)} theme='white'>
        <FormattedMessage {...messages.applyPreset} />
        {isFedexHal && (
          <Tooltip>
            <div>
              <FontAwesomeIcon className={style['information-icon']} icon={faInfoCircle} />
            </div>
            <TooltipContent>
              <FormattedMessage {...messages.containsFedexHalSelection} />
            </TooltipContent>
          </Tooltip>
        )}
      </CollapsibleListSectionHeader>
      <CollapsibleListSectionContent>
        <div className={style['apply-preset-container']}>
          {isLoading && <LoadingIndicator className={style['loading-indicator']} />}
          {!isLoading && (
            <div className={style['apply-preset-non-loading-content']}>
              <div className={style['bulk-update-wrapper']}>
                <div className={style.label}>
                  <FormattedMessage {...messages.presetLabel} />
                </div>
                <BulkAction
                  bulkActionId={BulkActions.applyShippingPreset.name}
                  jobData={jobData}
                  model={model}
                  onChange={(newModel) => onModelChange(bulkUpdateJobId, newModel)}
                />
                <Button
                  ariaLabel={intl.formatMessage(messages.managePresets)}
                  className={style['manage-presets-button']}
                  onClick={managePresets}
                >
                  <FontAwesomeIcon icon={faGear} />
                </Button>
              </div>
              <div className={style['buttons-footer']}>
                <Button disabled={!get(model, 'presetId')} onClick={() => applyPreset(bulkUpdateJobId)} theme='primary'>
                  <FormattedMessage {...messages.applyPreset} />
                </Button>
              </div>
            </div>
          )}
        </div>
      </CollapsibleListSectionContent>
    </CollapsibleListSection>
  );
};

ApplyPreset.propTypes = {
  open: PropTypes.bool,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  bulkUpdateJobId: PropTypes.string,
  isFedexHal: PropTypes.bool,
  model: BulkUpdateModelPropType,
  jobData: BulkJobDataPropType,
  onModelChange: PropTypes.func,
  applyPreset: PropTypes.func,
  managePresets: PropTypes.func,
  dragHandleProps: PropTypes.object,
};
